export default async (value = '') => {
  try {
    await navigator.clipboard.writeText(value);
  } catch (error) {
    throw Error(`ERROR:: Failed to copy: ${error}`);
  }
};
